import type { DisplayMode, PopupInstance, DisplayConfig } from '../types';

export class StandardDisplayMode implements DisplayMode {
	createContainer(popup: PopupInstance): HTMLElement {
		const { display, feedId } = popup.config;

		const overlay = document.createElement('div');
		overlay.className = `gf-popups-overlay gf-popups-overlay--standard ${display.customCssClass}`;
		overlay.dataset.feedId = String(feedId);
		overlay.style.zIndex = String(display.zIndex);
		overlay.setAttribute('aria-hidden', 'true');

		const backdrop = document.createElement('div');
		backdrop.className = 'gf-popups-backdrop';
		backdrop.style.backgroundColor = display.backdropColor;
		if (display.backdropBlur) {
			backdrop.style.backdropFilter = 'blur(4px)';
		}

		const dialog = document.createElement('div');
		dialog.className = 'gf-popups-dialog';
		dialog.setAttribute('role', 'dialog');
		dialog.setAttribute('aria-modal', 'true');
		dialog.style.width = display.popupWidth;
		if (display.popupHeight !== 'auto') {
			dialog.style.height = display.popupHeight;
		}

		if (display.showCloseButton) {
			const close = document.createElement('button');
			close.className = 'gf-popups-close';
			close.setAttribute('aria-label', 'Close');
			close.innerHTML = '&times;';
			close.addEventListener('click', () => popup.hide());
			dialog.appendChild(close);
		}

		const content = document.createElement('div');
		content.className = 'gf-popups-content';
		dialog.appendChild(content);

		overlay.appendChild(backdrop);
		overlay.appendChild(dialog);

		if (display.closeOnBackdropClick) {
			backdrop.addEventListener('click', () => popup.hide());
		}

		return overlay;
	}

	show(container: HTMLElement, config: DisplayConfig): void {
		container.removeAttribute('aria-hidden');
		requestAnimationFrame(() => {
			container.classList.add('gf-popups-overlay--visible');
		});
		document.body.style.overflow = 'hidden';
	}

	async hide(container: HTMLElement, config: DisplayConfig): Promise<void> {
		container.classList.remove('gf-popups-overlay--visible');
		container.setAttribute('aria-hidden', 'true');
		document.body.style.overflow = '';
		await new Promise(resolve => setTimeout(resolve, 300));
	}

	destroy(container: HTMLElement): void {
		document.body.style.overflow = '';
		container.remove();
	}
}
